import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { ProductForm } from '@/components/forms/ProductForm';
import { createProduct } from '@/api/products';
import { useQueryClient } from '@tanstack/react-query';
import { getCurrentDeveloperId } from '@/stores/authStore';
import type { CreateProductRequest } from '@/types/product';

/**
 * 创建产品页面
 */
export const ProductCreate = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const developerId = getCurrentDeveloperId();

  /**
   * 处理产品创建
   */
  const handleCreate = async (values: CreateProductRequest): Promise<void> => {
    try {
      const product = await createProduct(values);
      message.success(`产品 "${product.name}" 创建成功`);
      if (developerId) {
        queryClient.invalidateQueries({ queryKey: ['products', developerId] });
      }
      navigate(`/products/${product.id}`);
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : '产品创建失败，请检查参数后重试。';
      message.error(errorMessage);
    }
  };

  return (
    <div className="w-full space-y-8">
      {/* 统一页面标题层级 */}
      <div>
        <h1 className="text-2xl font-bold text-gray-800">创建产品</h1>
        <p className="text-gray-500 mt-1">填写产品信息并关联对应面板，创建后可集成到任意App中。</p>
      </div>
      <div className="max-w-2xl w-full">
        <ProductForm 
          mode="create" 
          onSubmit={(values) => handleCreate(values as CreateProductRequest)} 
        />
      </div>
    </div>
  );
};